import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  supportCard: { marginBottom: theme.spacing(1) },
  root: {
    backgroundColor: theme.palette.background.default,
    marginRight: -96,
    marginLeft: -96,
    marginTop: -20,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  header: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 1fr',
    gap: 24
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column'
  },
  addCreditorbutton: {
    marginTop: 12
  },
  color: {
    color: theme.palette.primary.main,
    fontSize: 48
  },
  tabSection: {
    marginTop: 36,
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  },
  filterButtonContainer: {
    marginTop: 10,
    marginBottom: 30,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 42,
    paddingTop: 6,
    paddingBottom: 6
  }
}))

export default useStyles
